import React, { Component } from "react";
import { Table, Spin, message, Tooltip } from "antd";
import { LoadingOutlined, InfoCircleOutlined } from "@ant-design/icons";
import instance from "../../store/actions/instance";
import NewWhatsAppTemplateModal from "./NewWhatsAppTemplateModal";

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
const { Column } = Table;

class WhatsAppTemplates extends Component {
  state = {
    templates: [],
    loading: true,
  };

  componentDidMount() {
    this.syncAndFetchTemplates();
  }

  syncAndFetchTemplates = async () => {
    try {
      this.setState({ loading: true });
      const res = await instance.get("/fetch_whatsapp_templates/");
      if (res.data.success) {
        const templates = res.data.fetched_templates;

        this.setState({ templates, loading: false });
      } else {
        message.error("Failed to load templates.");
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error("Fetch Error", error);
      message.error("Something went wrong while fetching templates.");
      this.setState({ loading: false });
    }
  };

  render() {
    const { newWhatsAppModalOpen } = this.props;
    const { templates, loading } = this.state;

    if (loading) {
      return (
        <div className="mt-5 text-center">
          <Spin indicator={antIcon} />
        </div>
      );
    }

    return (
      <div className="whiteSubContainer" style={{ padding: 20 }}>
        {newWhatsAppModalOpen && (
          <NewWhatsAppTemplateModal
            visible={newWhatsAppModalOpen}
            onClose={(fetchTemplates) => {
              this.props.closeModal();
              if (fetchTemplates) {
                this.syncAndFetchTemplates();
              }
            }}
          />
        )}
        <Table
          dataSource={templates}
          rowKey="name"
          pagination={{ pageSize: 10 }}
          rowClassName={"text-center"}
        >
          <Column title="Template name" dataIndex="name" key="name" />
          <Column title="Language" dataIndex="language" key="language" />
          <Column title="Status" dataIndex="status" key="status" />
        </Table>
      </div>
    );
  }
}

export default WhatsAppTemplates;
